/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Previous_SectionInputs */

const en_common_previous_section = /** @type {(inputs: Common_Previous_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous section`)
};

const es_common_previous_section = /** @type {(inputs: Common_Previous_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sección anterior`)
};

/**
* | output |
* | --- |
* | "Previous section" |
*
* @param {Common_Previous_SectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_previous_section = /** @type {((inputs?: Common_Previous_SectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Previous_SectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_previous_section(inputs)
	return en_common_previous_section(inputs)
});